// extracted by mini-css-extract-plugin
module.exports = {"reviewTitle":"testimonialHomeCard_reviewTitle__3Cw7F","img":"testimonialHomeCard_img__1dq1w","text":"testimonialHomeCard_text__tvJAN","location":"testimonialHomeCard_location__3Y2ZZ","name":"testimonialHomeCard_name__kWqWu"};
    if(module.hot) {
      // 1746134881460
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  